import { toastr } from "react-redux-toastr";
import { userConstants } from "../constants";
import { userService } from "../rest-services";
import { history } from "../helpers";
import axios from "axios";
import { getToken } from "../util/sessionUtil";
import { logoutCall } from "../util/userManager";

export const userActions = {
  saveEmail,
  searchEmail,
  bulkDownloadSales,
  salesDownloadFile,
  getSales,
  login,
  //logout,
  getInvoice,
  bulkDownloadFile,
  downloadFile,
  resetTable,
  getShipment,
  deleteFile,
  downloadFileShipment,
  bulkDownladInvoice,
  auditorList,
  auditorCreate,
  setCreateState,
  deleteInvoiceFile,
  deleteInvoiceStatus,
  updateAuditor,
  deleteAuditor,
};
function deleteInvoiceStatus(onCancel) {
  return (dispatch) => {
    dispatch(setBlockingState(false));
    dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
    onCancel();
  };
}
//Auditor List
function auditorList(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, reqBody, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Data response Auditor Data:", response.data);
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            dispatch(success(response.data));
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
    function success(data) {
      return { type: userConstants.UPDATE_AUDITOR_DATA, data };
    }
  };
}
function auditorCreate(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch(setCreateState(null));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, reqBody, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 201) {
            console.log("Response create Data:", response.data);
            dispatch(setBlockingState(false));
            dispatch(setCreateState(response.data));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
  };
}
function updateAuditor(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch(setCreateState(null));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .put(url, reqBody, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Response create Data:", response.data);
            dispatch(setBlockingState(false));
            dispatch(setCreateState(response.data));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
  };
}
function deleteAuditor(url) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch(setCreateState(null));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .delete(url, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200 || response.status === 204) {
            console.log("Response create Data:", response.data);
            dispatch(setBlockingState(false));
            dispatch(setCreateState(response.data));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
  };
}

function login(url, type) {
  return (dispatch) => {
    console.log("url:", url, "type:", type);
    axios.defaults.baseURL = "/shipment";
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then((response) => {
        dispatch(setBlockingState(false));
        if (response.status === 200) {
          dispatch({
            type: type,
            payload: response.data,
            user: response.data,
          });
          if (
            response.data.roles.includes("EDOC TME USER") ||
            response.data.roles.includes("EDOC NMSC USER") ||
            response.data.roles.includes("EDOC SUPPLIER USER") ||
            response.data.roles.includes("EDOC INVOICE ADMIN") ||
            response.data.roles.includes("EDOC INVOICE AUDITOR")
          ) {
            history.push("/invoiceSearch");
          } else if (
            response.data.roles.includes("EDOC VLG TME USER") ||
            response.data.roles.includes("EDOC VLG NMSC USER") ||
            response.data.roles.includes("EDOC TME AF USER")
          ) {
            history.push("/salesInvoice");
          } else if (response.data.roles.includes("EDOC PSCG ADMIN")) {
            history.push("/pscgInvoicingSystem");
          } else {
            history.push("/search");
          }
        }
      })
      .catch((err) => {
        console.log("err.response");
        console.log(err);
        //dispatch(setBlockingState(false));
        //dispatch(redirectToErrorPage("/errorPage", err.response));
      });
  };
}
function searchEmail(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, reqBody, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            dispatch(email(response.data));
          }
        },
        (error) => {
          dispatch(setBlockingState(false));
          dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
          toastr.error("Error", error.response.data.errorMessage);
        }
      );
    function email(data) {
      return { type: "EMAIL_DATA", data };
    }
  };
}
function saveEmail(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, reqBody, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 201) {
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            toastr.success("Values Saved Successfully");
          }
        },
        (error) => {
          dispatch(setBlockingState(false));
          dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
          toastr.error("Error", error.response);
        }
      );
  };
}
function getSales(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, reqBody, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            console.log("Data response:", response.data);
            dispatch(success(response.data));
          }
        },
        (error) => {
          dispatch(setBlockingState(false));
          dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          } else if (error.response.status === 406) {
            toastr.error("Error", error.response.data.errorMessage);
          }
        }
      );
    function success(data) {
      return { type: userConstants.UPDATE_TABLE_DATA, data };
    }
  };
}
function getShipment(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, reqBody, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Data response:", response.data);
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            dispatch(success(response.data));
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
    function success(data) {
      return { type: userConstants.UPDATE_TABLE_DATA, data };
    }
  };
}
function setBlockingState(isBlocked) {
  return function (dispatch) {
    dispatch({
      type: userConstants.SET_BLOCKING_STATE,
      payload: isBlocked,
    });
  };
}
function setDeleteState(isStatus) {
  return function (dispatch) {
    dispatch({
      type: userConstants.SET_DELETE_STATE,
      payload: isStatus,
    });
  };
}
function setCreateState(status) {
  return function (dispatch) {
    dispatch({
      type: userConstants.SET_CREATE_STATE,
      payload: status,
    });
  };
}

function resetTable() {
  return { type: userConstants.RESET_TABLE_DATA };
}

function downloadFileShipment(url, reqData) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          responseType: "arraybuffer",
          "Access-Control-Allow-Credentials": "true",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("file Loading");
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            var fileType = getFileType(reqData.filename);
            saveAsFile(response.data, fileType, reqData.filename);
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
  };
}

function salesDownloadFile(url, reqData) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          responseType: "arraybuffer",
          "Access-Control-Allow-Credentials": "true",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Sales file Loading");
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            var fileType = getFileType(reqData.filename);
            saveAsFile(response.data, fileType, reqData.fileDownload);
          }
        },
        (error) => {
          if (error.response.data.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            toastr.confirm("Session has expired. Please re-login!");
          } else {
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            if (
              error.response.data.message.includes(
                "The specified key does not exist"
              )
            ) {
              toastr.error("File Does not exist in the bucket");
            } else if (
              error.response.data.message.includes(
                "Cannot fetch credentials from container"
              )
            ) {
              toastr.error("Can't connect to aws in pc environment");
            } else {
              toastr.error("Unknown error occured,check the console");
            }
          }
        }
      );
  };
}

function bulkDownloadSales(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, JSON.stringify(reqBody), {
        headers: {
          "Content-Type": "application/json",
          responseType: "arraybuffer",
          "Access-Control-Allow-Credentials": "true",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("file Loading");
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            //var fileType = getFileType(reqBody.filename);
            saveAsFile(response.data, "application/zip", "vehicleSalesZip");
          }
        },
        (error) => {
          if (error.response.data.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          } else {
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            if (
              error.response.data.message.includes(
                "The specified key does not exist"
              )
            ) {
              toastr.error("File Does not exist in the bucket");
            } else if (
              error.response.data.message.includes(
                "Cannot fetch credentials from container"
              )
            ) {
              toastr.error("Can't connect to aws in pc environment");
            } else {
              toastr.error("Unknown error occured,check the console");
            }
          }
        }
      );
  };
}

//function of bulk download
function bulkDownloadFile(url, reqBody) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, JSON.stringify(reqBody), {
        headers: {
          "Content-Type": "application/json",
          responseType: "arraybuffer",
          "Access-Control-Allow-Credentials": "true",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("file Loading");
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            //var fileType = getFileType(reqBody.filename);
            saveAsFile(response.data, "application/zip", "shipmentZip");
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
  };
}
// function used for file downloading
function base64ToArrayBuffer(data) {
  console.log("Converting base64 to array buffer.");

  var binaryString = window.atob(data);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

function saveAsFile(base64Data, fileType, filename) {
  console.log("Saving data as file.");

  var arrBuffer = base64ToArrayBuffer(base64Data);

  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  var newBlob = new Blob([arrBuffer], { type: fileType });
  console.log("fileName:", filename);
  if (filename === "shipmentZip") {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob, "shipmentZip.zip");
      return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    var data = window.URL.createObjectURL(newBlob);

    var link = document.createElement("a");
    document.body.appendChild(link); //required in FF, optional for Chrome
    link.href = data;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(data);
    link.remove();
  } else if (filename === "invoiceZip") {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob, "invoiceZip.zip");
      return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    var data = window.URL.createObjectURL(newBlob);

    var link = document.createElement("a");
    document.body.appendChild(link); //required in FF, optional for Chrome
    link.href = data;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(data);
    link.remove();
  } else {
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob, filename);
      return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    var data = window.URL.createObjectURL(newBlob);

    var link = document.createElement("a");
    document.body.appendChild(link); //required in FF, optional for Chrome
    link.href = data;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(data);
    link.remove();
  }
}

function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

function getFileType(filename) {
  if (endsWith(filename, "html") || endsWith(filename, "xml")) {
    return "plain/text";
  } else if (endsWith(filename, "pdf")) {
    return "application/pdf";
  } else {
    return "application/octet-stream";
  }
}
//Multi delete service
function deleteFile(url, reqdata, reqBody, urlSearch) {
  return (dispatch) => {
    console.log(reqBody, urlSearch);
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, JSON.stringify(reqdata), {
        headers: {
          "Content-Type": "application/json",
          responseType: "arraybuffer",
          "Access-Control-Allow-Credentials": "true",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Delete the multi record");
            dispatch(setBlockingState(false));
            dispatch(setDeleteState(true));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            dispatch(getShipment(urlSearch, reqBody));
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
  };
}
function deleteInvoiceFile(url, reqdata, reqBody, onSuccess) {
  return (dispatch) => {
    console.log(reqBody);
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, JSON.stringify(reqdata), {
        headers: {
          "Content-Type": "application/json",
          responseType: "arraybuffer",
          "Access-Control-Allow-Credentials": "true",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Delete Invoice the multi record");
            dispatch(setBlockingState(false));
            dispatch(setDeleteState(true));
            onSuccess();
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            dispatch(getInvoice(reqBody));
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          }
          // else{
          //     toastr.error('Error',error.response);
          // }
        }
      );
  };
}

function getInvoice(reqBody) {
  axios.defaults.baseURL = "";
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    userService.getInvoice(reqBody).then(
      (data) => {
        dispatch(setBlockingState(false));
        dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
        console.log(data);
        dispatch(success(data));
      },
      (error) => {
        dispatch(setBlockingState(false));
        dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });

        console.log("Server response has error code " + error.response.status);
        if (error.response.status === 401) {
          // for error codes 401, show option for re-login
          console.log("Asking user for log back in.");

          logoutCall();

          //toastr.error('Error', error.response.data);
          toastr.confirm("Session has expired. Please re-login!");
        } else if (error.response.status === 406) {
          toastr.error("Error", error.response.data.errorMessage);
        }
      }
    );
  };

  function success(data) {
    return { type: userConstants.UPDATE_TABLE_DATA, data };
  }
}
function downloadFile(reqBody) {
  axios.defaults.baseURL = "";
  return function (dispatch) {
    return userService.downloadFile(reqBody).then(
      (res) => {
        var fileType = getFileType(reqBody.filename);
        dispatch(setBlockingState(false));
        dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
        saveAsFile(res.data, fileType, reqBody.filename);
      },
      (error) => {
        console.log("Server response has error code " + error.response.status);
        if (error.response.status === 401) {
          // for error codes 401, show option for re-login
          console.log("Asking user for log back in.");

          logoutCall();

          toastr.error("Error", error.response.data);
          toastr.confirm("Would you like to log back in ?");
        } else {
          toastr.error("Error", error.response.data);
        }
      }
    );
  };
}
function bulkDownladInvoice(url, reqBody, onRefresh) {
  return (dispatch) => {
    dispatch(setBlockingState(true));
    dispatch({ type: userConstants.SHOW_LOADING_SPINNER, show: true });
    axios.defaults.baseURL = "/shipment";
    axios
      .post(url, JSON.stringify(reqBody), {
        headers: {
          "Content-Type": "application/json",
          responseType: "arraybuffer",
          "Access-Control-Allow-Credentials": "true",
          Authorization: "Bearer " + getToken(),
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("file Loading");
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            //var fileType = getFileType(reqBody.filename);
            saveAsFile(response.data, "application/zip", "invoiceZip");
            onRefresh();
          }
        },
        (error) => {
          if (error.response.status === 401) {
            console.log("Asking user for log back in.");
            logoutCall();
            //toastr.error('Error', error.response.data);
            toastr.confirm("Session has expired. Please re-login!");
          } else if (error.response.status === 406) {
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            toastr.error(
              "Error",
              "Size should not be more than 50 MB.Please refine your search criteria."
            );
            onRefresh();
          } else if (error.response.status === 417) {
            dispatch(setBlockingState(false));
            dispatch({ type: userConstants.HIDE_LOADING_SPINNER, show: false });
            toastr.error(
              "Error",
              "There is nothing to download.Please refine your search criteria."
            );
            onRefresh();
          }
        }
      );
  };
}
